import React from 'react';
import style from './index.module.scss';

export type HelpTooltipProps = {
    text: string;
    className?: string;
};

export const HelpTooltip = ({text, className}: HelpTooltipProps) => {
    const classes = [style.helpButton, className].filter(Boolean).join(' ');
    return (
        <button type="button" className={classes} aria-label={text}>
            <i className={['fa fa-info-circle', style.icon].join(' ')} aria-hidden="true" />
            <span className={style.tooltip} role="tooltip">
                {text}
            </span>
        </button>
    );
};